<template>
  <div class="c-vpsmp">
    <div class="c-vpsmp-main">
      <div class="c-vpsmp-container" ref="containerRef">
        <single-pkg
          v-for="(item, index) in pricingList"
          class="c-vpsmp-item"
          ref="singlePkgRef"
          :key="index"
          :pkg="item"
          :isLiuziPage="isLiuziPage"
        />
      </div>
    </div>
    <!-- <div :style="cControlStyle" class="c-vpsmp-control">
      <span class="c-vpsmp-control__prev" @click="onScrollPrevItem"></span>
      <span class="c-vpsmp-control__next" @click="onScrollNextItem"></span>
    </div> -->
  </div>
</template>

<script>
import { throttle } from 'lodash';
import { smoothScroll } from '@/common/utils';
import SinglePkg from '@/components/PricePkgs/SinglePkg.vue';

export default {
  name: 'pricing',

  props: {
    pricingList: Array,
    isLiuziPage: Boolean,
  },

  data() {
    return {
      scrollControlVisible: false,
    };
  },

  computed: {
    cControlStyle() {
      return {
        height: this.scrollControlVisible ? '48px' : '0',
        opacity: this.scrollControlVisible ? 1 : 0,
      };
    },
  },

  components: {
    SinglePkg,
  },

  mounted() {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },

  methods: {
    onWindowResize: throttle(function () {
      const containerRef = this.$refs.containerRef;
      if (!containerRef) return;
      containerRef.scrollLeft = 10;
      const existenceScrollBar = containerRef.scrollLeft > 0;
      this.scrollControlVisible = existenceScrollBar;
    }, 100),

    onScrollPrevItem() {
      const rect = this.getSinglePkgRect();
      if (!rect) return;
      const { width } = rect;
      const currentScrollLeft = this.$refs.containerRef.scrollLeft;
      const distance = width + 24; // 24为marign
      let nextDistance = currentScrollLeft - distance;
      if (nextDistance < distance) {
        nextDistance = currentScrollLeft;
      }
      smoothScroll(
        this.$refs.containerRef,
        this.$refs.containerRef.scrollLeft - distance,
        false,
      );
    },

    onScrollNextItem() {
      const rect = this.getSinglePkgRect();
      if (!rect) return;
      const { width } = rect;
      const distance = width + 24; // 24为marign
      smoothScroll(
        this.$refs.containerRef,
        this.$refs.containerRef.scrollLeft + distance,
        false,
      );
    },

    getSinglePkgRect() {
      const [singlePkgRef] = this.$refs.singlePkgRef;
      if (!singlePkgRef) return;
      const width = singlePkgRef?.$el?.clientWidth;
      return {
        width,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.c-vpsmp {
  &-main {
    width: 100%;
    position: relative;
  }

  &-container {
    width: 100%;
    display: flex;
    gap: 24px;
    overflow-x: hidden;
    box-sizing: content-box;
    padding: 24px;
    margin: -24px -24px 0;
  }

  &-item {
    flex-shrink: 0;
  }

  &-control {
    width: 112px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    transition-property: height, opacity;
    transition-duration: 0.3s, 0.3s;
    margin: 0 auto;

    &__prev,
    &__next {
      display: block;
      width: 48px;
      height: 48px;
      background-image: url('../../images/prev.svg');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
    }

    &__next {
      transform: rotate(180deg);
    }
  }
}
</style>
